import { faMoneyCheckPen, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Dialog from "@radix-ui/react-dialog";
import classNames from "classnames";
import React from "react";
import ReactDiffViewer from "react-diff-viewer";

import { LLMResponse } from "@/types";

import styles from "../LLMSidebar.module.scss";
import { removeContentTokens } from "../utils";

interface DiffButtonProps {
  markdownBefore: string | undefined;
  response: LLMResponse;
}

const DiffButton: React.FC<DiffButtonProps> = ({ markdownBefore, response }) => {
  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <button className={styles.white}>
          <FontAwesomeIcon icon={faMoneyCheckPen} />
          See changes
        </button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.dialogOverlay} />
        <Dialog.Content className={styles.dialogContent}>
          <Dialog.Close asChild>
            <button className={styles.iconButton} aria-label="Close">
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </Dialog.Close>
          <div className={styles.diff}>
            <ReactDiffViewer
              oldValue={removeContentTokens(markdownBefore ?? "")}
              newValue={removeContentTokens(response?.response ?? "")}
              splitView={true}
            />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default DiffButton;
